// Logos da marca Methos
export const LOGOS = {
  // Wordmark completo "methos - Corretora" - fundo transparente (PNG)
  WORDMARK: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/mce4m1jv_METHOS_NF1.png",

  // Logo com fundo branco (JPG)
  FULL_WHITE_BG: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/f0rwi6wf_LOGO%20COMPLETO%201%20FUNDO%20BRANCO.jpg",

  // Logo com fundo azul escuro (JPG)
  FULL_DARK_BG: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/k6tdiiri_LOGO%20COMPLETO%201%20FUNDO%20AZUL%20ESCURO.jpg",

  // Logo simples fundo branco (JPG)
  SIMPLE_WHITE_BG: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/l65caizl_LOGO%201%20FUNDO%20BRANCO.jpg",

  // Logo simples fundo azul escuro (JPG)
  SIMPLE_DARK_BG: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/1zp8x6wh_LOGO%201%20FUNDO%20AZUL%20ESCURO.jpg",

  // Logo "M" estilizado (PNG transparente) - versão ícone/reduzida
  ICON_GRADIENT: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/fn1mxb44_VERSA%CC%83O%20ESPECIAL%205%20PNG_1.png",

  // Logo "M" estilizado variante (PNG transparente)
  ICON_GRADIENT_ALT: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/a999nt14_VERSA%CC%83O%20ESPECIAL%206%20PNG_1.png",

  // Logo PNG fundo azul escuro (transparente)
  SIMPLE_DARK_PNG: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/uh695c9y_LOGO%201%20FUNDO%20AZUL%20ESCURO%20PNG.png",

  // Logo PNG fundo azul (transparente)
  SIMPLE_BLUE_PNG: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/hdgw3dnm_LOGO%201%20FUNDO%20AZUL%20PNG.png",
};

// Elementos decorativos (rabiscos da marca)
export const DECORATIVE = {
  RABISCO_BLUE: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/ypuhknt5_RABISCO%204%20AZUL%20ESCURO.jpg",
  RABISCO_ORANGE: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/791g8mck_RABISCO%201%20LARANJA.jpg",
  RABISCO_AZUL_DG: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/7e610ihh_RABISCO%201%20AZUL%20DG.jpg",
  RABISCO_AZUL: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/julpvwjn_RABISCO%204%20AZUL.jpg",
  RABISCO_ORANGE_2: "https://customer-assets.emergentagent.com/job_dde57437-c3dd-4bdb-b925-69c881b30f1d/artifacts/cox9lg3n_RABISCO%202%20LARANJA.jpg",
};

// Paleta de cores da marca
export const COLORS = {
  PRIMARY_DARK: "#0A2F3D",
  PRIMARY_BLUE: "#3B82F6",
  ACCENT_ORANGE: "#F26A4B",
  SIDEBAR_BG: "#0A2F3D",
};
